import React from 'react';
import Section from '@hero/ui-kit/layout/Section';
import Table from '@hero/ui-kit/tables/Table';
import H from '@hero/ui-kit/typography/H';

import InlineLoader from '../../../components/InlineLoader';
import useListStyles from '../../../hooks/useListStyles';

import DeviceListFiltering from '../DevicesListFiltering';
import useDevicesListData from './useDevicesListData';
import { DeviceTableItem } from './getTableColumns';
import DefaultLayout from '../../../components/DefaultLayout';

const DeviceList: React.FC = () => {
    const { isFetchingDevices, devices, sort, handleSort, pagerProps, tableColumns } =
        useDevicesListData();
    const { headerWrapStyles, innerWrapPadding, tableWrapStyles } = useListStyles();

    return (
        <DefaultLayout>
            <Section
                subtheme={['regular', 'background']}
                paddingVertical="small"
                paddingHorizontal="regular"
            >
                <div style={headerWrapStyles}>
                    <H role="h5">Device Lookup</H>
                </div>
                <div style={innerWrapPadding}>
                    {isFetchingDevices ? (
                        <InlineLoader />
                    ) : (
                        <>
                            <DeviceListFiltering />
                            <div style={tableWrapStyles}>
                                <Table<DeviceTableItem>
                                    columns={tableColumns}
                                    data={devices}
                                    rowKey="id"
                                    emptyValues="-"
                                    isLoading={isFetchingDevices}
                                    sortColumn={sort.sort_by}
                                    sortDirection={sort.sort_dir}
                                    onColumnSort={handleSort}
                                    pagerProps={pagerProps}
                                />
                            </div>
                        </>
                    )}
                </div>
            </Section>
        </DefaultLayout>
    );
};

export default DeviceList;
